import listSaga from './listSaga'

const integrationServices = [listSaga()]

export default integrationServices
